
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 900 600"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"900","height":"600","fill":"#d7141a"}}),_c('rect',{attrs:{"width":"900","height":"300","fill":"#fff"}}),_c('path',{attrs:{"d":"M450 300L0 0v600z","fill":"#11457e"}})])
          )
        }
      }
    